<template>
  <div class="crud_form_wrapper">
    <!-- Start:: Title -->
    <div class="form_title_wrapper">
      <h2>{{ $t("PLACEHOLDERS.showOrder") }}</h2>
    </div>
    <div class="col-12 text-end">
      <v-btn @click="$router.go(-1)" style="color: #E1423D">
        <i class="fas fa-backward"></i>
      </v-btn>
    </div>
    <!-- End:: Title -->

    <!-- Start:: Single Step Form Content -->
    <div class="single_step_form_content_wrapper">
      <form @submit.prevent="validateFormInputs">
        <div class="row">
          <!-- Start:: Order Data -->
          <h5 style="font-weight: 600; color: #E1423D;">{{ $t("PLACEHOLDERS.orderData") }}</h5>
          
          <base-input
            col="4"
            type="text"
            :placeholder="$t('PLACEHOLDERS.orderNum')"
            v-model.trim="data.order_number"
            disabled
          />

          <base-input
            col="4"
            type="text"
            :placeholder="$t('PLACEHOLDERS.orderCreate')"
            v-model.trim="data.created_at"
            disabled
          />

          <base-input
            col="4"
            type="text"
            :placeholder="$t('PLACEHOLDERS.orderStatus')"
            v-model="data.status_display"
            disabled
          />
          <hr class="my-4" style="width: 97%;"/>
          <!-- Start:: Client Data -->
          <h5 class="col-12 mt-4" style="font-weight: 600; color: #E1423D;">{{ $t("PLACEHOLDERS.userData") }}</h5>

          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.clientName')"
            v-model="data.client_name"
            disabled
          />

          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.clientPhone')"
            v-model="data.client_phone"
            disabled
          />
          <!-- End:: Client Data -->
          <hr class="my-4" style="width: 97%;"/>
          <!-- Start:: Products Data -->
          <div class="col-12 mt-4" v-if="data.items && data.items.length">
            <h5 style="font-weight: 600; color: #E1423D;">{{ $t("PLACEHOLDERS.productData") }}</h5>

            <div v-for="(item, index) in data.items" :key="item.id" class="mb-4 row">
              <div>
                <v-chip class="my-2" style="width: 70px;">{{ $t("PLACEHOLDERS.product") + " " + (index + 1) }}</v-chip>
              </div>
              
              <base-input
                col="6"
                type="text"
                :placeholder="$t('PLACEHOLDERS.productName') + ' #' + (index + 1)"
                v-model.trim="item.product_name"
                disabled
              />

              <base-input
                col="6"
                type="text"
                :placeholder="$t('PLACEHOLDERS.unitPrice') + ' #' + (index + 1)"
                v-model.trim="item.unit_price"
                disabled
              />

              <base-input
                col="6"
                type="text"
                :placeholder="$t('PLACEHOLDERS.quantatyy') + ' #' + (index + 1)"
                v-model.trim="item.quantity"
                disabled
              />

              <base-input
                col="6"
                type="text"
                :placeholder="$t('PLACEHOLDERS.totalPrice') + ' #' + (index + 1)"
                v-model.trim="item.total_price"
                disabled
              />

              <!-- Product Rating (only for finished orders) -->
              <div class="col-12 mt-2" v-if="data.status === 'delivered' && item.product_rating">
                <label class="form-label">{{ $t("PLACEHOLDERS.productRating") }}</label>
                <rating-preview :rate="item.product_rating" />
              </div>
            </div>
          </div>
          <!-- End:: Products Data -->
          <hr class="my-4" style="width: 97%;"/>
          <!-- Start:: Payment Data -->
          <h5 class="col-12 mt-4" style="font-weight: 600; color: #E1423D;">{{ $t("PLACEHOLDERS.priceData") }}</h5>

          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.paymentMethod')"
            v-model="data.payment_method_display"
            disabled
          />

          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.subtotal')"
            v-model="data.subtotal"
            disabled
          />

          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.totalTax')"
            v-model="data.tax_amount"
            disabled
          />

          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.deliveryFee')"
            v-model="data.delivery_fee"
            disabled
          />

          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.discountAmount')"
            v-model="data.discount_amount"
            disabled
          />

          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.walletAmountUsed')"
            v-model="data.wallet_amount_used"
            disabled
          />

          <base-input
            col="12"
            type="text"
            :placeholder="$t('PLACEHOLDERS.totalOrderPrice')"
            v-model="data.total"
            disabled
          />
          <!-- End:: Payment Data -->
          <hr class="my-4" style="width: 97%;"/>
          <!-- Start:: Reviews/Ratings (only for finished orders that have been rated) -->
          <div class="col-12 mt-4" v-if="data.status === 'delivered' && data.reviews && data.reviews.length">
            <h5 style="font-weight: 600; color: #E1423D;">{{ $t("PLACEHOLDERS.rates") }}</h5>
            
            <div v-for="(review, index) in data.reviews" :key="index" class="mb-4 row">
              <div>
                <v-chip class="my-2" style="width: 70px;">{{ $t("PLACEHOLDERS.review") + " #" + (index + 1) }}</v-chip>
              </div>
              
              <div v-if="review.rating" class="mb-2">
                <label class="form-label">{{ $t("PLACEHOLDERS.rating") + " #" + (index + 1) }}</label>
                <rating-preview :rate="review.rating" />
              </div>

              <base-input
                col="12"
                type="textarea"
                :placeholder="$t('PLACEHOLDERS.comment') + ' #' + (index + 1)"
                v-model.trim="review.comment"
                disabled
              />
            </div>
          </div>
          <!-- End:: Reviews/Ratings -->
          <hr class="my-4" style="width: 97%;" v-if="data.status === 'delivered' && data.reviews && data.reviews.length" />
          <!-- Start:: Address Data -->
          <h5 class="col-12 mt-4" style="font-weight: 600; color: #E1423D;">{{ $t("PLACEHOLDERS.addressData") }}</h5>

          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.addressTitle')"
            v-model.trim="data.address_title"
            disabled
          />

          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.addressDetails')"
            v-model.trim="data.address_details"
            disabled
          />

          <base-input
            col="4"
            type="text"
            :placeholder="$t('PLACEHOLDERS.region')"
            v-model.trim="data.region_name"
            disabled
          />

          <base-input
            col="4"
            type="text"
            :placeholder="$t('PLACEHOLDERS.city')"
            v-model.trim="data.city_name"
            disabled
          />

          <base-input
            col="4"
            type="text"
            :placeholder="$t('PLACEHOLDERS.district')"
            v-model.trim="data.district_name"
            disabled
          />

          <!-- Map Location -->
          <div class="col-12" v-if="data.address_latitude && data.address_longitude">
            <label class="form-label" style="color: #E1423D; font-size: 16px;">{{ $t("PLACEHOLDERS.mapLocation") }}:</label>
            <div class="map-container" style="height: 300px; width: 100%; border: 1px solid #ddd; border-radius: 6px;">
              <iframe
                :src="`https://www.google.com/maps?q=${data.address_latitude},${data.address_longitude}&hl=${getAppLocale}&z=15&output=embed`"
                width="100%"
                height="100%"
                frameborder="0"
                style="border:0; border-radius: 6px;"
                allowfullscreen
              ></iframe>
            </div>
          </div>
          <!-- End:: Address Data -->
        </div>
      </form>
    </div>
    <!-- END:: Single Step Form Content -->
  </div>
</template>

<script>
import RatingPreview from "../../../components/ui/RatingPreview.vue";
import { mapGetters } from "vuex";

export default {
  components: { RatingPreview },
  name: "ShowOrder",
  
  computed: {
    ...mapGetters({
      getAppLocale: "AppLangModule/getAppLocale",
    }),
  },

  data() {
    return {
      // Start:: Loader Control Data
      isWaitingRequest: false,
      loading: false,
      // End:: Loader Control Data

      // Start:: Data Collection
      data: {
        order_number: null,
        created_at: null,
        status: null,
        status_display: null,
        address_title: null,
        address_details: null,
        region_name: null,
        city_name: null,
        district_name: null,
        address_latitude: null,
        address_longitude: null,
        client_name: null,
        client_phone: null,
        items: [],
        payment_method: null,
        payment_method_display: null,
        subtotal: null,
        tax_amount: null,
        delivery_fee: null,
        discount_amount: null,
        wallet_amount_used: null,
        total: null,
        reviews: [],
      },
      regions: [],
      cities: [],
      districts: [],
      // End:: Data Collection
    };
  },

  methods: {
    getStatusName(status) {
      const statusMap = {
        new: this.$t("PLACEHOLDERS.new"),
        processing: this.$t("PLACEHOLDERS.processing"),
        ready_for_delivery: this.$t("PLACEHOLDERS.ready_for_delivery"),
        on_the_way: this.$t("PLACEHOLDERS.on_the_way"),
        delivered: this.$t("PLACEHOLDERS.delivered"),
        cancelled: this.$t("PLACEHOLDERS.cancelled"),
      };
      return statusMap[status] || status;
    },

    getPaymentMethodName(method) {
      const methodMap = {
        cash: this.$t("PLACEHOLDERS.cash"),
        electronic: this.$t("PLACEHOLDERS.electronic"),
        wallet: this.$t("PLACEHOLDERS.wallet"),
      };
      return methodMap[method] || method;
    },

    formatDate(dateString) {
      if (!dateString) return "-";
      const date = new Date(dateString);
      const pad = n => n < 10 ? `0${n}` : n;
      const year = date.getFullYear();
      const month = pad(date.getMonth() + 1);
      const day = pad(date.getDate());
      const hours = pad(date.getHours());
      const minutes = pad(date.getMinutes());
      const seconds = pad(date.getSeconds());
      return `${year}-${month}-${day}, ${hours}:${minutes}:${seconds}`;
    },

    async getRegionName(regionId) {
      try {
        const cached = this.regions.find(r => r.id === regionId);
        if (cached) return cached.name;
        
        let res = await this.$axios({
          method: "GET",
          url: `regions/${regionId}`,
        });
        if (res.data.data) {
          this.regions.push({ id: regionId, name: res.data.data.name || res.data.data.name_ar || res.data.data.name_en });
          return res.data.data.name || res.data.data.name_ar || res.data.data.name_en;
        }
      } catch (error) {
        console.log("Error fetching region:", error);
      }
      return null;
    },

    async getCityName(cityId) {
      try {
        const cached = this.cities.find(c => c.id === cityId);
        if (cached) return cached.name;
        
        let res = await this.$axios({
          method: "GET",
          url: `cities/${cityId}`,
        });
        if (res.data.data) {
          this.cities.push({ id: cityId, name: res.data.data.name || res.data.data.name_ar || res.data.data.name_en });
          return res.data.data.name || res.data.data.name_ar || res.data.data.name_en;
        }
      } catch (error) {
        console.log("Error fetching city:", error);
      }
      return null;
    },

    async getDistrictName(districtId) {
      try {
        const cached = this.districts.find(d => d.id === districtId);
        if (cached) return cached.name;
        
        let res = await this.$axios({
          method: "GET",
          url: `districts/${districtId}`,
        });
        if (res.data.data) {
          this.districts.push({ id: districtId, name: res.data.data.name || res.data.data.name_ar || res.data.data.name_en });
          return res.data.data.name || res.data.data.name_ar || res.data.data.name_en;
        }
      } catch (error) {
        console.log("Error fetching district:", error);
      }
      return null;
    },

    // Start:: Show Order Data
    async showOrder() {
      this.loading = true;
      try {
        let res = await this.$axios({
          method: "GET",
          url: `orders/${this.$route.params.id}`,
        });
        
        const order = res.data.data;
        
        // Order Basic Data
        this.data.order_number = order.order_number;
        this.data.created_at = this.formatDate(order.created_at);
        this.data.status = order.status;
        this.data.status_display = this.getStatusName(order.status);

        // Address Data
        if (order.address) {
          this.data.address_title = order.address.title;
          this.data.address_details = order.address.details;
          this.data.address_latitude = order.address.latitude;
          this.data.address_longitude = order.address.longitude;

          // Fetch region, city, district names
          if (order.address.region_id) {
            this.data.region_name = await this.getRegionName(order.address.region_id);
          }
          if (order.address.city_id) {
            this.data.city_name = await this.getCityName(order.address.city_id);
          }
          if (order.address.district_id) {
            this.data.district_name = await this.getDistrictName(order.address.district_id);
          }
        }

        // Client Data
        if (order.user) {
          this.data.client_name = order.user.name;
          this.data.client_phone = order.user.phone;
        }

        // Products/Items Data
        if (order.items && order.items.length) {
          this.data.items = order.items.map(item => ({
            id: item.id,
            product_name: item.product?.name || "-",
            unit_price: item.unit_price,
            quantity: item.quantity,
            total_price: item.total_price,
            product_rating: item.product?.average_rating || null,
          }));
        }

        // Payment Data
        this.data.payment_method = order.payment_method;
        this.data.payment_method_display = this.getPaymentMethodName(order.payment_method);
        this.data.subtotal = order.subtotal;
        this.data.tax_amount = order.tax_amount;
        this.data.delivery_fee = order.delivery_fee || "0.00";
        this.data.discount_amount = order.discount_amount || "0.00";
        this.data.wallet_amount_used = order.wallet_amount_used || "0.00";
        this.data.total = order.total;

        // Reviews (only for delivered orders)
        if (order.reviews && order.reviews.length) {
          this.data.reviews = order.reviews.map(review => ({
            rating: review.rating || null,
            comment: review.comment || null,
          }));
        }

        this.loading = false;
      } catch (error) {
        this.loading = false;
        console.log(error.response?.data?.message || error.message);
        this.$message.error(error.response?.data?.message || this.$t("MESSAGES.error"));
      }
    },
    // End:: Show Order Data
  },

  created() {
    // Start:: Fire Methods
    this.showOrder();
    // End:: Fire Methods
  },
};
</script>
<style>
.comment {
  border: 1px solid #E1423D;
  padding: 15px;
  border-radius: 6px;
}
.comment_label {
  color: #E1423D;
  font-size: 16px;
}
.map-container {
  margin-top: 10px;
}
</style>
